<div
  class="plan-card d-flex flex-column h-100 mx-auto border overflow-hidden"
  [ngClass]="'plan-card--' + variant"
  [class.plan-card--elevated]="elevated"
  [class.plan-card--icon-in-header]="iconInHeader"
  [class.plan-card--has-badge]="badgeText"
>
  <span *ngIf="showStripe" class="plan-card__stripe flex-shrink-0"></span>

  <div class="plan-card__body d-flex flex-column flex-grow-1 py-3 px-4">
    <div class="plan-card__header d-flex align-items-start justify-content-between">
      <div class="plan-card__heading">
        <h3 class="plan-card__title m-0">{{ title }}</h3>
        <p *ngIf="subtitle" class="plan-card__subtitle mt-2 mb-0">{{ subtitle }}</p>
      </div>

      <div class="plan-card__header-aside d-flex align-items-center flex-shrink-0">
        <span *ngIf="badgeText" class="plan-card__badge fw-bold text-nowrap rounded-pill">
          {{ badgeText }}
        </span>
        <ng-container *ngIf="iconInHeader" [ngTemplateOutlet]="productVisual"></ng-container>
      </div>
    </div>

    <hr class="plan-card__divider my-3" />

    <div *ngIf="showPriceRow" class="plan-card__price-row d-flex align-items-baseline gap-2 mb-2">
      <span *ngIf="originalPrice" class="plan-card__price-original text-decoration-line-through">
        {{ originalPrice }}
      </span>

      <div *ngIf="price" class="plan-card__price-stack d-flex flex-column">
        <span class="plan-card__price"
          >{{ price }}<span class="plan-card__price-suffix">/yr</span></span
        >
        <span *ngIf="monthlyPrice" class="plan-card__price-monthly"
          >or {{ monthlyPrice }}<span class="plan-card__price-suffix">/pm</span></span
        >
      </div>

      <ng-container *ngIf="!iconInHeader" [ngTemplateOutlet]="productVisual"></ng-container>
    </div>

    <div class="plan-card__features d-flex flex-column mb-4">
      <ng-container *ngIf="inheritedLabel">
        <div class="plan-card__feature d-flex align-items-start">
          <ng-container *ngTemplateOutlet="tick"></ng-container>
          <span>{{ inheritedLabel }}</span>
        </div>
        <div class="plan-card__plus-label fw-semibold">Plus</div>
      </ng-container>

      <div class="plan-card__feature d-flex align-items-start" *ngFor="let feature of features">
        <ng-container *ngTemplateOutlet="tick"></ng-container>
        <span>{{ feature }}</span>
      </div>

      <p *ngIf="infoLine" class="plan-card__info-line text-center m-0">{{ infoLine }}</p>
    </div>

    <div class="plan-card__actions d-flex flex-column">
      <p *ngIf="ctaNote" class="plan-card__cta-note text-center m-0">{{ ctaNote }}</p>

       <button
        type="button"
        class="plan-card__cta d-inline-flex align-items-center justify-content-center w-100 lh-1 fw-bold rounded-pill"
        [disabled]="disabled || loading"
        (click)="selectPlan.emit()"
      >
        {{ ctaText }}
      </button>

      <button
        *ngIf="secondaryCtaText"
        type="button"
        class="plan-card__cta plan-card__cta--secondary d-inline-flex align-items-center justify-content-center w-100 lh-1 fw-bold rounded-pill"
        [disabled]="loading"
        (click)="secondaryAction.emit()"
      >
        {{ secondaryCtaText }}
      </button>

    </div>
  </div>
</div>

<!-- Product image plus its decorative colorways: sits beside the title or the price. -->
<ng-template #productVisual>
  <img
    *ngIf="iconSrc"
    [src]="iconSrc"
    alt=""
    class="plan-card__icon object-fit-contain flex-shrink-0 align-self-center ms-auto"
  />
  <span
    *ngIf="colorOptions.length"
    class="plan-card__colors d-flex flex-column align-self-center flex-shrink-0"
    aria-hidden="true"
  >
    <span
      *ngFor="let color of colorOptions"
      class="plan-card__color rounded-circle"
      [style.background-color]="color"
    ></span>
  </span>
</ng-template>

<!-- Circle fill is currentColor, so the card variant sets the color via CSS. -->
<ng-template #tick let-muted="muted">
  <span class="plan-card__check flex-shrink-0" [class.plan-card__check--muted]="muted">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="currentColor" />
      <path
        d="M6 12.5L10 16.5L18 8"
        stroke="white"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</ng-template>
